export const chat = {
  assistantName: 'Victor AI',
  statusOnline: 'Online',
  welcomeMessage:
    "Ciao! Sono l'Assistente di Victor. Ti aiuto a capire quale soluzione fa per te: Foundation per la presenza online o Launch per l'automazione completa. Dimmi, di cosa si occupa la tua azienda?",
  messagePlaceholder: 'Scrivi un messaggio...',
  thinking: 'Sto pensando...',
  openChat: 'Apri chat',
  typingStatus: 'AI sta pensando...',
  tabs: {
    info: 'Victor AI',
    email: 'Modulo di contatto',
  },
  modes: {
    info: {
      welcome: {
        title: 'Incontra l\'Assistente di Victor',
        description:
          'Chiedimi del piano Foundation o Launch, quali sono le differenze, o come possiamo aiutare la tua azienda a crescere online.',
      },
    },
    email: {
      title: 'Inviami un messaggio',
      description: 'Compila il modulo sottostante per metterti in contatto direttamente con Victor.',
      form: {
        name: 'Il tuo nome',
        email: 'La tua email',
        message: 'Il tuo messaggio',
        send: 'Invia',
        sending: 'Invio in corso...',
        success: 'Messaggio inviato con successo!',
        error: 'Impossibile inviare il messaggio. Riprova per favore.',
      },
    },
  },
  prompts: {
    services: 'Quali servizi offrite?',
    foundation: 'Dimmi di più sul piano Foundation',
    launch: 'Dimmi di più sul piano Launch',
    contact: 'Come posso parlare direttamente con Victor?',
  },
  error: 'Errore durante la generazione della risposta',
  form: {
    title: 'Inserisci i tuoi dati di contatto',
    name: 'Nome completo',
    email: 'Email',
    phone: 'Telefono',
    company: 'Azienda',
    namePlaceholder: 'Il tuo nome completo',
    emailPlaceholder: 'tua@email.com',
    phonePlaceholder: '+39 333 123 4567',
    companyPlaceholder: 'Nome della tua azienda',
    nameRequired: 'Il nome è obbligatorio',
    emailRequired: 'L\'email è obbligatoria',
    emailInvalid: 'Inserisci un\'email valida',
    phoneRequired: 'Il telefono è obbligatorio',
    phoneInvalid: 'Inserisci un numero di telefono valido',
    companyRequired: 'L\'azienda è obbligatoria',
    fillAllFields: 'Compila tutti i campi correttamente',
    saved: 'Informazioni salvate!',
    saveError: 'Errore nel salvataggio',
    saveWarning: 'Le informazioni verranno salvate quando il server sarà disponibile',
    sending: 'Invio in corso...',
    send: 'Invia',
    submitError: 'Errore nell\'invio del form',
  },
};